module.exports = __webpack_public_path__ + "static/img/services_banner.fc55596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/services_banner.jpg
// module id = 597
// module chunks = 0